export default __webpack_public_path__ + "static/media/samar.ac4dc394.jfif";